module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av701-1e6e7e91c173bf341ae9f8fcd1d9fd34.jpg";